import { IUser } from 'features/auth/types'
import { ICall } from 'features/calls/types'
import { EDITABLE_PHONE_SLOTS } from 'features/claims/components/ClaimDetails/ProviderRecord/Internal/EntityVersions'
import { IClaimEntities } from 'features/claims/types'
import { IEntity, IEntityBag } from 'features/entities/types'
import { sortBy } from 'lodash'
import { formatPhoneNumber } from 'utils'

/**
 * Accepts an IUser parameter and returns given name plus the first letter of the first name or Anonymous if one of the props is missing
 *
 * @param user IUser | null
 * @returns string
 */
export const getShortAgentName = (user?: IUser | null): string => {
  const { family_name, given_name } = user || { family_name: '', given_name: '' }
  return family_name && given_name ? `${given_name} ${family_name.charAt(0)?.toUpperCase()}.` : 'Anonymous'
}

export const getLongAgentName = (user?: IUser | null): string => {
  const { family_name, given_name } = user || { family_name: '', given_name: '' }
  return family_name && given_name ? `${given_name} ${family_name}` : 'Anonymous Agent'
}

/**
 *
 * @param entityBag IEntityBag
 * @param entities IEntity[]
 * @returns entities IClaimEntities
 */
export const getClaimEntities = (entityBag: IEntityBag, entities: IEntity[]): IClaimEntities => {
  const claimEntities: IClaimEntities = {}
  entityBag.entityVersions?.forEach((entityVersion) => {
    claimEntities[entityVersion.entityId!] = {
      name: entities.find((entity) => entity.entityId === entityVersion.entityId!)?.description || 'N/A',
      value: EDITABLE_PHONE_SLOTS.includes(
        entities.find((entity) => entity.entityId === entityVersion.entityId!)?.slot ?? '',
      )
        ? formatPhoneNumber(entityVersion.entityValue!)
        : entityVersion.entityValue,
      type: entities.find((entity) => entity.entityId === entityVersion.entityId!)?.typeId || 'N/A',
    }
  })

  return claimEntities
}

export const getCallIndexFromClaim = (calls: ICall[], callId: string): number | '' => {
  return sortBy(calls, 'jobRequested').findIndex((call) => call.jbId == callId) + 1 || ''
}

/**
 * check current user is owner/non-owner
 */
export const isCurrentUserClaimOwner = (claimOwnerId: string | undefined, currentUser: IUser): boolean => {
  return currentUser.id === claimOwnerId
}

/**
 * Check is current claim has owner
 */
export const isCurrentClaimHasOwner = (claimOwner: string | undefined, claimOwnerId: string | undefined) => {
  if ((claimOwner && claimOwner === 'anonymous') || !claimOwnerId) {
    return false
  }
  return true
}
